import { ZoneType } from "@/types"
import { ColumnDef } from "@tanstack/react-table"

import { DataTableColumnHeader } from "../../data-table"
import { ZonesOperation } from "../operations/zones-operations"

export const zonesColumns: ColumnDef<ZoneType>[] = [
  {
    accessorKey: "zone_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone_id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone_name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "meter_reading_schedule",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Meter Reading Schedule" />
    ),
    cell: ({ row }) => {
      const value = row.original.meter_reading_schedule
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone_description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone_description
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone_capacity",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone Capacity" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone_capacity
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <ZonesOperation data={row.original} />
        </div>
      )
    },
  },
]
